import { Skeleton } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { DataLake, Organization } from '@finley-technologies/finley-types';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { ExploDashboardContainer } from 'packages/explo/ui/ExploDashboardContainer';
import { QuickSightContainer } from 'packages/quickSight/ui/QuickSightContainer';

export const PortfolioStratsContainer: React.FC<{
  creditFacilityId: string;
}> = withLDConsumer()(({ creditFacilityId, flags }) => {
  const history = useHistory();

  const { data: userData } = useGetUserQuery();

  if (!userData || !userData.user) {
    return (
      <Skeleton
        height="600px"
        data-testid="portfolio-strats-container-missing-user"
      />
    );
  }

  if (!flags) {
    return (
      <Skeleton
        height="600px"
        data-testid="portfolio-strats-container-missing-flag"
      />
    );
  }

  // Technically this should never hit as the route has already hidden this,
  // but just keeping as extra safety
  if (flags.showLenderPortfolioStrats === 'hide') {
    history.push('/portfolio/overview/facilities');
    return <Skeleton height="600px" />;
  }

  if (flags.showLenderPortfolioStrats === 'explo') {
    return (
      <ExploDashboardContainer
        organizationId={userData.user.organizationId}
        creditFacilityId={creditFacilityId}
      />
    );
  }

  if (flags.showLenderPortfolioStrats === 'quicksight') {
    return (
      <QuickSightContainer
        containerId="qs-portfolio-capital-provider-strats-dashboard"
        embedType={DataLake.QuicksightEmbedType.Dashboard}
        embedUrlQueryParams={{
          organizationId: userData.user.organizationId,
          organizationType: Organization.OrganizationType.CapitalProvider,
          dataType: DataLake.QuickSightDataType.ReceivableResponseTape,
          creditFacilityId,
          latest: true,
        }}
        embedStyling={{
          height: '704',
          resizeHeightOnSizeChangedEvent: true,
        }}
      />
    );
  }

  // This path should technically never hit
  history.push('/portfolio/overview/facilities');
  return <Skeleton height="600px" />;
});
